import * as Sentry from '@sentry/nextjs';

/**
 * Fouten van de Vinyl Lettering Designer naar Sentry (eindreview I1).
 *
 * Eigen tag `feature: 'vst-designer'`, zodat een storing in de designer (bundel
 * laadt niet, toevoegen gooit, registratie faalt op de server) in Sentry apart te
 * filteren is. Voorheen alleen `console.error`: onzichtbaar.
 * Faalt nooit: melden mag de handeling zelf niet omver trekken.
 */
export type VstDesignerStage = 'load' | 'add-to-cart' | 'register';

export function reportVstDesignerError(stage: VstDesignerStage, error: unknown, extra?: Record<string, unknown>): void {
  try {
    const fout = error instanceof Error ? error : new Error(typeof error === 'string' ? error : JSON.stringify(error));
    Sentry.captureException(fout, {
      tags: { feature: 'vst-designer', vst_stage: stage },
      ...(extra ? { extra } : {}),
    });
  } catch {
    // Monitoring stuk is geen reden om de klant te storen.
  }
}
